import Vue from 'vue';
import AppNav from './Nav';
import AppSearch from './Search';
import MobileNav from './NavMobile';
import DesktopNav from './NavDesktop';
import AppLink from "./Link";

Vue.component('app-nav', AppNav);
Vue.component('app-search', AppSearch);
Vue.component('app-link', AppLink);

/**
 * This takes care of instantiating the new vue instance for the nav.
 */
new Vue({
    el: '[nav-root-mobile]',
    components: { MobileNav },
    render (h) {
        return h(MobileNav)
    }
});

new Vue({
    el: '[nav-root-desktop]',
    components: { DesktopNav },
    render (h) {
        return h(DesktopNav)
    }
});
